<template>
  <v-form
    v-model="formAlumnoIdiomasValid"
    @submit.prevent="onSubmit($event)"
  >
    <v-card-text>
      <v-row
        v-for="(itemIdioma, index) in idiomasAlumno"
        :key="index"
      >
        <v-col cols="5">
          <v-select
            :items="idiomasDisponibles(itemIdioma.idioma)"
            item-text="nombre"
            item-value="nombre"
            label="Idioma"
            v-model="itemIdioma.idioma"
            :key="index"
            no-data-text="Selecciona un idioma"
            return-object
            required
            :rules="idiomaRules"
          ></v-select>
        </v-col>

        <v-col cols="5">
          <v-select
            :items="niveles"
            label="Nivel"
            v-model="itemIdioma.nivel"
            :key="index"
            item-text="descripcion"
            item-value="descripcion"
            no-data-text="Selecciona un nivel"
            :disabled="!itemIdioma.idioma"
            return-object
            clearable
          ></v-select>
        </v-col>

        <v-col cols="2" class="pt-6">
          <v-btn
              color="error"
              icon
              @click="borrarIdioma(index)"
          >
            <v-icon>mdi-delete</v-icon>
          </v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="5">
          <v-select
            :items="[]"
            label="Idioma"
            disabled
          ></v-select>
        </v-col>

        <v-col cols="5">
          <v-select
            :items="[]"
            label="Nivel"
            disabled
          ></v-select>
        </v-col>

        <v-col cols="2" class="pt-6">
          <v-btn
            color="primary"
            icon
            @click="nuevoIdioma"
            :disabled="allowIdiomas()"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions>
      <v-btn
        type="submit"
        color="primary"
        :loading="loadingGuardar"
        text
        :disabled="!allowSave()"
      >
        Guardar
      </v-btn>
    </v-card-actions>
  </v-form>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'AlumnoIdiomasForm',

  props: {
    idiomas: {
      type: Array,
      required: true,
    },

    niveles: {
      type: Array,
      required: true,
    },

    alumno: {
      type: Object,
      required: true,
    },

    idiomasAlumno: {
      type: Array,
      required: true,
    },

    loadingGuardar: {
      type: Boolean,
      default: () => false,
    },

    allowSaveEmpty: {
      type: Boolean,
      default: () => true,
    },
  },

  data: () => {
    return {
      formAlumnoIdiomasValid: false,
      idiomaRules: [
        v => !!v || 'Selecciona una opción',
      ],
    }
  },

  methods: {
    allowSave() {
      if (!this.formAlumnoIdiomasValid) {
        return false
      }

      if (_.isEmpty(this.idiomasAlumno) && !this.allowSaveEmpty) {
        return false;
      }

      return true
    },

    /**
     * Añade una nueva fila al formulario de idiomas
     */
    nuevoIdioma() {
      let nuevoIdioma = {
        id: null,
        alumno: this.alumno.id,
        // si el idioma esta vacio enviamos un null
        idioma: null,
        // si el nivel esa vacio enviamos un null
        nivel: null
      }

      this.idiomasAlumno.push(nuevoIdioma)
    },

    /**
     * Accion de borrar un idioma del array de idiomas del alumno
     */
    async borrarIdioma(index) {
      this.$emit('delete', event, index)
    },

    /**
     * Filtra los idiomas a mostrar en los combos de idioma teniendo en
     * cuenta si es el seleccionado en ese combo o si no esta en ninguno
     * de ellos.
     */
    idiomasDisponibles(currentIdioma) {
      let idiomasSeleccionados = []
      this.idiomasAlumno.forEach(alumnoIdioma => {
        if (alumnoIdioma.idioma != null) {
          idiomasSeleccionados.push(alumnoIdioma.idioma.id)
        }
      })

      return this.idiomas.filter((idioma) => {
        // hay idioma seleccionado y es igual al idioma que estamos filtrando
        if (currentIdioma != null && idioma.id == currentIdioma.id) {
          return true
        }

        // el idioma que estamos filtrando ya esta seleccionado por el usuario
        if (idiomasSeleccionados.includes(idioma.id)) {
          return false
        }

        return true;
      })
    },

    /**
     * Dejamos añadir idiomas tantos como diferentes idiomas hay en la base de datos.
     */
    allowIdiomas() {
      return this.idiomas.length <= this.idiomasAlumno.length
    },

    onSubmit(event) {
      this.$emit('submit', event)
    },
  },
}
</script>
